module.exports = __webpack_public_path__ + "img/record.1137486f.png";